import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { brandingService } from "services";
import { uiActions } from "store";
import { BrandingSettingsTypes, ErrorResponse } from "types";

const useSetBrandingAlignmentSettingsAgentMutation = (agentId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		({ settings }: { settings: BrandingSettingsTypes }) => {
			return brandingService.setBrandingAlignmentSettingsAgent({
				agentId,
				settings: {
					logo_alignment: settings.logoAlignment,
					text_alignment: settings.textAlignment,
				},
			});
		},
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useSetBrandingAlignmentSettingsAgentMutation;
